import styled from 'styled-components';
import theme from 'styled-theming';
import colors from '../../../theme/Colors';

const activeColor = theme('brand', {
    brenntag: colors.brenntag.secondary, 
    bcd: colors.bcd.primary
});

export const SNavbar = styled.div`
    height: 73px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
    background-color: white;
    display: flex;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
`;

export const SNavbarList = styled.ul`
    list-style-type: none;
`;

export const SNavbarListItem = styled.li`
    display: inline;
    
    &:not(:last-child) {
        margin-right: 50px;
    }
    a {
        text-decoration: none;
        color: #777;
    }
    .active {
        color: ${activeColor};
    }
`;